import React from "react";

// Types
import { FormBuilderFieldProps } from "../../types";

// Components
import { IonCheckbox, IonToggle } from "@ionic/react";
import { InputFactory } from "../../components/Factories/Input";

export default class BasicFormBuilderFields extends React.Component<FormBuilderFieldProps, any> {
  render() {
    const { question, hideRequiredColumn } = this.props;

    // Exclude required fields from being configurable
    const exclude: string[] = ["email", "password", "password_confirmation"];
    if (exclude.includes(question.key)) return null;

    if (question) {
      return (
        <div className="form-builder-fields">
          <div>{this.props.allowEditing ? <InputFactory type="text" name="name" value={question.name} onIonChange={(e: CustomEvent) => this.props.handleChange?.(e, question)} /> : question.name}</div>
          <div>
            <IonToggle name="visible" className="input__toggle" checked={this.hasRule("visible")} mode="md" onClick={this.handleToggle} />
          </div>
          {!hideRequiredColumn && (
            <div>
              {/* @ts-ignore */}
              <IonCheckbox name="required" checked={this.hasRule("required")} mode="md" onClick={this.handleToggle} value={this.hasRule("required")} type="checkbox" />
            </div>
          )}
        </div>
      );
    }
  }

  hasRule = (rule: string): boolean => {
    return this.props.question && this.props.question.hasOwnProperty("rules") && Array.isArray(this.props.question.rules) && this.props.question.rules.some((r: string) => r === rule);
  };

  handleToggle = (e: any) => {
    const key = e.detail.name ? e.detail.name : e.target.name;
    let { question } = this.props;

    if (this.hasRule(key)) {
      question.rules = question.rules.filter((rule: string) => ![key].includes(rule));
    } else {
      if (!Array.isArray(question.rules)) question.rules = [];
      question.rules.push(key);
    }

    this.props.handleChange?.(e, question);
  };
}
